import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import remove from "../../../../assets/svg/delete.svg";
import svg37 from "../../../../assets/svg/svg37.svg";
import svg25 from "../../../../assets/svg/svg25.svg";
import {  fetchSubwalletDropdown } from "../../../../features/fetch/fetchSlice";
import { fetchPayments } from "../../../../features/fetch/fetchSlice";

const { TextArea } = Input;
const FilterModal = ({
  isModalOpen,
  handleCancel,
  prodd,
  formData,
  setFormData,
  filters,
  setFilters,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {subwalletData} = useSelector((state)=>state.fetch)
  const {user} = useSelector((state)=>state.auth)
  const items = [
    {
      label: "Source Wallet",
      key: "Source Wallet",
    },
    {
      label: "Payment Desc",
      key: "Payment Desc",
    },
  ];

  // const [filters, setFilters] = useState([]);

  const filteredItems = items.filter(
    (item) => !filters?.some((filter) => filter?.value === item?.key)
  );

  const settingItems = filteredItems?.map((item) => ({
    key: item?.key,
    label: (
      <div
        className="font-dmSans text-black font-[400] text-[19px] mt-[5%]"
        onClick={() => handleMenuItemClick(item?.key)}
      >
        {item?.label}
      </div>
    ),
  }));

  const handleMenuItemClick = (itemKey) => {
    if (itemKey === "Source Wallet") {
      const newFilter = {
        type: "Source Wallet",
        value: "Source Wallet",
      };
      setFilters([...filters, newFilter]);
    } else if (itemKey === "Payment Desc") {
      const newFilter = {
        type: "Payment Desc",
        value: "Payment Desc",
      };
      setFilters([...filters, newFilter]);
    }
   
  };

  const removeFilter = (index) => {
    const updatedFilters = filters?.filter((_, idx) => idx !== index);
    setFilters(updatedFilters);
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      if (filters[index].type === "Source Wallet") {
        delete updatedData.pyWalId;
      }
      else if (filters[index].type === "Payment Desc") {
        delete updatedData.pyPurpose;
      }
      return updatedData;
    });
  };

  // const [formData, setFormData] = useState();

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function handleSelectChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const handleNumberChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      manualPaymentReceiverMobileNo: String(e),
    }));
  };

  const onFinish = async (data) => {
    const res = await dispatch(
          fetchPayments({
            url: "api/v1/payments/fetch-payments", 
            pyEntryType: "DIRECT", 
            pyWalId:formData?.pyWalId,
            pyPurpose:formData?.pyPurpose
          })
    );
    if (res?.payload?.success) {
      // toast.success(res.payload?.messages?.message);
      handleCancel();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const handleClear = async () => {
    await setFilters([]);
    await setFormData({});
    await handleCancel();
  };

  async function fetchSubWalletData() {
    dispatch(
      fetchSubwalletDropdown({
        url: `api/v1/wallet/sub/${user?.disbursementWalId}`,
      })
    );
  }
  useEffect(() => {
    fetchSubWalletData();
  }, []);

  return (
    <>
      <Modal
        className="!mt-[13%] filter-modal "
        title="New Account "
        open={isModalOpen}
        onCancel={handleCancel}
        width={800}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className="px-[15px]"
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="flex justify-between text-black21 text-[18px] font-normal leading-[24px] font-dmSans mb-5">
            <div className="">Filters</div>
            <div className="cursor-pointer" onClick={handleClear}>
              Clear
            </div>
          </div>
          <div className="grid grid-cols-1">
            <span className="text-black21 text-[18px] font-normal leading-[24px] font-dmSans mt-5">
              All filters
            </span>
            {filters?.map((filter, index) => (
              <div
                key={index}
                className="flex flex-col items-start mt-4 w-full"
              >
                {filter.type === "Source Wallet" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                      <Select
                        name="pyWalId"
                        value={formData?.pyWalId}
                        className=""
                        allowClear
                        placeholder="Select source wallet"
                        style={{
                          width: "100%",
                        }}
                        onChange={(value) => {
                          handleSelectChange(value, "pyWalId");
                        }}
                        options={
                          subwalletData?.length > 0 &&
                          subwalletData?.map((item) => ({
                            value: item?.walId,
                            label: item?.walName,
                          }))
                        }
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label?.toLocaleLowerCase() ?? "").includes(
                            input?.toLocaleLowerCase()
                          )
                        }
                        onDropdownVisibleChange={() => {}}
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}
                 {filter.type === "Payment Desc" && (
                  <div className="flex items-center w-full gap-x-2">
                    <Form.Item className="w-[100%]">
                      <Input
                        className="input"
                        name={`input-${index}`}
                        value={filter.value}
                        readOnly={true}
                      />
                    </Form.Item>
                    <Form.Item className="w-[100%]">
                    <Input
                        name="pyPurpose"
                        className="input"
                        onChange={onChange}
                        value={formData?.pyPurpose}
                        placeholder="Enter payment description."
                      />
                    </Form.Item>
                    <Form.Item className="w-[20%]">
                      <button onClick={() => removeFilter(index)}>
                        <img src={remove} alt="remove-icon" />
                      </button>
                    </Form.Item>
                  </div>
                )}
              </div>
            ))}

            <div className="flex justify-between items-center">
              <Dropdown
                overlayStyle={{
                  width: "200px",
                }}
                trigger={"click"}
                menu={{ items: settingItems }}
                placement="bottom"
              >
                <Button
                  type="btn"
                  className="flex items-center w-[150px] bg-[#A3A2A7] text-white h-[45px] py-3 px-2
                 rounded-[10px] gap-x-1 mb-10 mt-5 !text-lexendS text-[16px] font-[500]"
                >
                  <img src={svg25} alt="add-icon" />
                  Add Filter
                  <img src={svg37} alt="svg37" />
                </Button>
              </Dropdown>

              {filters && filters?.length > 0 && (
                <div className="w-[150px]">
                  <button type="submit" className="cstm-btn-2">
                    submit
                  </button>
                </div>
              )}
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default FilterModal;
